module.exports = __webpack_public_path__ + "static/home-01-fa4860c5d9f10d5bdfdb7e9a2adf1acf.png";